// extracted by mini-css-extract-plugin
export default {"legend":"Legend_legend__WMg-r","legendItem":"Legend_legendItem__0dh8s","legendMark":"Legend_legendMark__nnOdi","legendTitle":"Legend_legendTitle__yr-ME"};